import React from 'react'
import styled from 'styled-components'
import { Modal, Button } from 'advenio-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 16px;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  flex: 1;
  margin-top: 32px;
`

const DeleteActivityModal = ({ open, onClose, onDeleteActivity, loading }) => {
  return (
    <Modal
      isOpened={open}
      onClose={onClose}
      headerTitle="Eliminar Actividad"
      statePath="activity"
      actionType="delete_activity"
      typePrefix="ACTIVITY"
    >
      <Container>
        <span>
          ¿Estás seguro que deseas eliminar la actividad?
        </span>
        <ButtonsContainer>
          <Button
            ghost
          >
            Cancelar
          </Button>
          <Button
            primary
            loading={loading}
            onClick={onDeleteActivity}
          >
            Aceptar
          </Button>
        </ButtonsContainer>
      </Container>
    </Modal>
  )
}

export default DeleteActivityModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/DeleteActivityModal.jsx